module.exports = __webpack_public_path__ + "static/media/steering-stering-suspension-evaluation-red.4c89147c.svg";